import { api } from "./configs/axiosConfigs"

export const CartolaDepartmentAPI = {
    get: async (payload?: object) => {
        const response = await api.get(
            '/cartola', { params: payload }
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    generatePDF: async (iddepartment: number, start_date: string, end_date: string, idcompany: number) => {
        const response = await api.get(
            '/cartola/PDF',
            {
                params: {
                    iddepartment,
                    start_date,
                    end_date,
                    idcompany
                },
                responseType: 'blob'
            }
        ).then(response => response)
            .catch((error) => {
                console.error(error)
                return error.response
            })
        return response
    },
}